/* eslint-disable max-len, no-plusplus */

const isProduction = window.location.origin.includes('universe.com')
const isConsentRevoked = () => !window.OnetrustActiveGroups?.includes('C0004')

const iframe = document.createElement('iframe')
iframe.setAttribute('id', 'facebook-pixel-frame')
iframe.setAttribute('width', 0)
iframe.setAttribute('height', 0)
iframe.setAttribute('src', 'about:blank')
iframe.setAttribute('style', 'display:none')
document.body.appendChild(iframe)

const writeIframeContent = () => {
  // Don't render iframe if we don't have permission
  if (isProduction && isConsentRevoked()) return false

  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(`
    <html>
      <head>
        <script>
          !function(f,b,e,v,n,t,s) {
            if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
          }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
        </script>
      </head>
    </html>
  `)
  return doc.close()
}

const removeIframeContent = () => {
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write('')
  doc.close()
}

const initFacebookPixel = (facebookPixelCodes) => {
  if (iframe.contentWindow.document.readyState === 'complete') {
    writeIframeContent()
  } else {
    iframe.onload = writeIframeContent
  }

  const iframeWindow = iframe.contentWindow
  let retries = 0

  const checkFbqAvailability = () => {
    if (iframeWindow.fbq) {
      const { fbq } = iframeWindow
      facebookPixelCodes.forEach((code) => {
        fbq('set', 'autoConfig', false, code)
        fbq('init', code)
      })
      fbq('track', 'PageView')

      document.addEventListener('unii:tracking:metapixel', ((data) => {
        fbq(data.detail.command, data.detail.sendTo, data.detail.target, data.detail.options, { eventID: data.detail.eventId })
      }), false)
    } else {
      if (retries++ > 5) return
      setTimeout(checkFbqAvailability, 500)
    }
  }

  checkFbqAvailability()
}

export default (facebookPixelCodes) => {
  initFacebookPixel(facebookPixelCodes)

  // Listenener for OneTrust consent changes
  window.OptanonWrapper = () => {
    if (isConsentRevoked()) {
      removeIframeContent()
    } else {
      initFacebookPixel(facebookPixelCodes)
    }
  }
}
